import { Injectable } from '@angular/core';
import { Regex, ErrorMessage } from '../../constants';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(public datepipe: DatePipe) {

  }
  public formatDate(dob: string) {
    if (dob.length == 8) {
      dob = dob.slice(0, 2) + '/' + dob.slice(2, 4) + '/' + dob.slice(4);
      
    }
    if (dob.length < 10 || !Regex.date.test(dob)) {
      return null;
    }
    let dateObj = new Date(+dob.split('/')[2], +dob.split('/')[1] - 1, +dob.split('/')[0]);
    if (dateObj.toDateString() != "Invalid Date") {
      let age = this.isValidDateRange(dateObj)
      var today = new Date();
      if (age > 99 || today < dateObj) {
        return ErrorMessage.providePrimaryDOB;
      }
    }
    return dateObj.toDateString();
  }

  public customDateFormat(dob: any, format: string) {
    return this.datepipe.transform(dob, format)
  }

  public isValidDateRange(date: Date) {
    var today = new Date();
    var age = today.getFullYear() - date.getFullYear();
    var m = today.getMonth() - date.getMonth();
    console.log(today.getDate() , date.getDate())
    if (m < 0 || (m === 0 && today.getDate() > date.getDate())) {
        age--;
    }
    return age;
    
  }

  maskEmail(email: string) {
    var pos = email.indexOf('@');
    var domain = email.split('@');
    var maskedEmail = [];
    maskedEmail.push(email[0])
    for (var i = 1; i < pos; i++) {
      if (i % 2 !== 0) {
        maskedEmail.push('*');
      }
      else {
        maskedEmail.push(email[i]);
      }
    }
    return maskedEmail.join('') + '@' + domain[1];
  }

  maskTelephone(telephone: string) {
    var maskedTelephone = [];
    for (var i = 0; i < telephone.length; i++) {
      if (i % 2 !== 0) {
        maskedTelephone.push('*');
      }
      else {
        maskedTelephone.push(telephone[i]);
      }
    }
    return maskedTelephone.join('');
  }
}
